import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EdfUpdateGlyph = /*#__PURE__*/createElement("g", {
  id: "edf_update"
}, /*#__PURE__*/createElement("path", {
  d: "M35.3 51.2h-4v2.6h4.4v2h-6.9V45h6.6v2h-4.2v2.2h4v2zM37.4 45.2c.9-.2 2.1-.2 3.3-.2 2.1 0 3.4.4 4.4 1.2 1.1.8 1.8 2.1 1.8 4.1 0 2.1-.8 3.5-1.8 4.4-1.1.9-2.9 1.4-5 1.4-1.3 0-2.2-.1-2.8-.2V45.2zm2.4 8.8h.8c2.2 0 3.7-1.2 3.7-3.8 0-2.2-1.3-3.4-3.4-3.4-.5 0-.9 0-1.1.1V54zM48.6 45h6.6v2H51v2.5h3.9v2H51v4.3h-2.4V45z"
}), /*#__PURE__*/createElement("path", {
  d: "M59.3 18.9v46.2H24.7V18.9h34.6m2-2.9H22.7c-.5 0-1 .4-1 1v50c0 .5.4 1 1 1h38.6c.5 0 1-.4 1-1V17c0-.6-.5-1-1-1z"
}));
const EdfUpdate = createSvg({
  name: 'edf_update',
  path: EdfUpdateGlyph
});

export default EdfUpdate;
export { EdfUpdateGlyph };
